import api from "src/apis/api"

// Registry-driven provider settings (Exotel / MSG91 / Spring Edge). Secrets are
// write-only: the server returns "<secret>_present" booleans, never the values.
export async function fetchProviderSettings(provider) {
  const { data } = await api.get(`/api/v1/communications/provider_settings/${provider}`)
  return data.config
}

export async function updateProviderSettings(provider, config) {
  const { data } = await api.patch(`/api/v1/communications/provider_settings/${provider}`, { config })
  return data.config
}

export async function testProviderConnection(provider, to_address) {
  const { data } = await api.post(`/api/v1/communications/provider_settings/${provider}/test`, { to_address })
  return data
}

// Per-channel provider routing (which provider carries whatsapp / sms / call).
export async function fetchRouting() {
  const { data } = await api.get("/api/v1/communications/routing_settings")
  return data
}

export async function updateRouting(routing) {
  const { data } = await api.patch("/api/v1/communications/routing_settings", { routing })
  return data
}

// Enabled + configured providers per channel, e.g.
//   { channels: { call: [{ key, name, default }], sms: [...], whatsapp: [...] },
//     routing: { call: "exotel", ... } }
// Drives the send-time picker: 2+ options -> show a chooser, otherwise dispatch
// silently through the single/default provider.
export async function fetchAvailableProviders() {
  const { data } = await api.get("/api/v1/communications/available_providers")
  return data
}
